import { CustomModelAutomaticMutationSideEffectConfigs } from "../types";

export const ENDUSER_ORDERS_MUTATION_SIDE_EFFECT_CONFIGS: CustomModelAutomaticMutationSideEffectConfigs<"enduser_orders"> =
  {};
